<template>
  <div>
    <div class="admin-container">
      <div class="admin-header">
        <div class="admin-header-left">
          <router-link to="/admin/set" tag="div">
            <div class="iconfont set-icon">&#xe636;</div>
          </router-link>
        </div>
        <!-- {{localStorage.username}} -->
        <div class="admin-header-center">欢迎您,{{getUsername}}</div>
        <div class="admin-header-right">
          <div class="iconfont clock-icon">&#xe633;</div>
        </div>
      </div>
      <div class="admin-main">
        <div class="admin-avatar">
          <van-image :src="IMG_PATH + '/logo.jpg'">
            <template v-slot:loading>
              <van-loading type="spinner" size="20"/>
            </template>
          </van-image>
        </div>
      </div>
      <div class="admin-footer">
        <div class="admin-data">
          <div class="admin-data-num">{{info.currdayOrderNum}}</div>
          <div class="admin-data-text">当天下单数</div>
        </div>
        <router-link tag="div" to="/admin/order/sum" class="admin-data">
          <div class="admin-data-num">{{info.currdaySummary}}</div>
          <div class="admin-data-text">订单汇总</div>
        </router-link>
        <div class="admin-data">
          <div class="admin-data-num">{{info.currdayTotalPrice}}</div>
          <div class="admin-data-text">当天总业绩</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {IMG_PATH} from '@/source'
export default {
  props: {
    info: {
      type: Object
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    getUsername() {
      return localStorage.username;
    },
    IMG_PATH() {
      return IMG_PATH
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@style/varibles.styl';

.admin-container {
  width: 100%;
  height: 6.7rem;
  background: #e83b56;
  color: #fff;

  .admin-header {
    height: $headerHeight;
    display: flex;

    .admin-header-left, .admin-header-right {
      width: 1rem;
      text-align: center;
    }

    .admin-header-center {
      flex: 1;
      line-height: $headerHeight;
      text-align: center;
      font-size: 0.32rem;
    }

    .iconfont {
      height: 100%;
      line-height: $headerHeight;
      font-size: 0.5rem;
    }
  }

  .admin-avatar {
    width: 2.5rem;
    height: 2.5rem;
    margin: 0.6rem auto 0.5rem auto;
    border: 5px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .admin-avatar img {
    max-width: 100%;
  }

  .admin-footer {
    display: flex;
    position: relative;
    height: 2rem;
    justify-content: space-between;
    align-items: center;

    .line {
      width: 1px;
      background: #fff;
      height: 1.5rem;
    }

    .admin-data {
      text-align: center;
      font-size: 0.28rem;
      flex: 1;
      line-height: 1.6;

      .admin-data-num {
        font-family: Arial;
        font-size: 0.5rem;
      }
    }
  }
}
</style>
